var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.66 111.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_250770464",
    "data-name": 250770464,
    d: "M163.33,137.54m-8.7-15.2-2.78,2.78,7.1,7.1a2.25,2.25,0,0,1,0,3.2l-7.1,7.11,2.78,2.78,7.1-7.1a2.27,2.27,0,0,1,1.6-.67,2.24,2.24,0,0,1,1.6.67l7.11,7.1,2.77-2.78-7.11-7.11a2.27,2.27,0,0,1,0-3.2l7.11-7.11L172,122.34l-7.11,7.11a2.31,2.31,0,0,1-1.61.66,2.29,2.29,0,0,1-1.6-.66l-7.09-7.11Z",
    transform: "translate(-3.12 -49.67)",
    fill: "#00a",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_250769736",
    "data-name": 250769736,
    d: "M163.33,108.22a25.61,25.61,0,1,0,25.6,25.61,25.64,25.64,0,0,0-25.6-25.61Zm-6.42,10,6.42,6.43,6.43-6.43a3.21,3.21,0,0,1,4.56,0l4.62,4.62h0a3.25,3.25,0,0,1,0,4.55l-6.44,6.43,6.43,6.43a3.24,3.24,0,0,1,0,4.56l-4.62,4.61a3.22,3.22,0,0,1-4.56,0L163.33,143l-6.42,6.42a3.23,3.23,0,0,1-2.28.95,3.27,3.27,0,0,1-2.29-.94l-4.61-4.62a3.22,3.22,0,0,1,0-4.56l6.42-6.43-6.42-6.42a3.21,3.21,0,0,1,0-4.56l4.61-4.62a3.24,3.24,0,0,1,4.57,0Z",
    transform: "translate(-3.12 -49.67)",
    fill: "#fc3",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_250769568",
    "data-name": 250769568,
    d: "M111.22,51.25a19,19,0,0,1,6,9.32l4,14.47h71.11a.87.87,0,0,0,.71-.35.88.88,0,0,0,.15-.79l-4.43-15.8a9.42,9.42,0,0,0-9-6.85Z",
    transform: "translate(-3.12 -49.67)",
    fill: "none",
    stroke: "#fc3",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_250769288",
    "data-name": 250769288,
    d: "M86.67,51.25H18.12a9.43,9.43,0,0,0-9,6.85L4.65,73.9a.89.89,0,0,0,.15.78.86.86,0,0,0,.71.35H75.94a.92.92,0,0,0,.87-.66l3.87-13.81a19,19,0,0,1,6-9.31Z",
    transform: "translate(-3.12 -49.67)",
    fill: "none",
    stroke: "#fc3",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_250769120",
    "data-name": 250769120,
    d: "M75.94,79.56H24v66.82a3.26,3.26,0,0,0,2.79,3.21l69.92,9.51V51.43A14.5,14.5,0,0,0,85,61.8L81.16,75.61a5.45,5.45,0,0,1-5.22,4ZM42.88,130.41a2.26,2.26,0,0,1-.33,4.5l-.34,0-8.42-1.26a2.26,2.26,0,1,1,.66-4.48Zm-.45,9.75a2.26,2.26,0,0,1-.33,4.5l-.34,0-8.42-1.26a2.26,2.26,0,1,1,.67-4.48l8.42,1.27Z",
    transform: "translate(-3.12 -49.67)",
    fill: "none",
    stroke: "#00a",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_250767048",
    "data-name": 250767048,
    d: "M101.21,51.43V159.11l39.51-5.38a30.13,30.13,0,0,1,33.2-48.12v-26H119.56a2.27,2.27,0,0,1-2.18-1.65l-4.51-16.12a14.56,14.56,0,0,0-11.66-10.36Z",
    transform: "translate(-3.12 -49.67)",
    fill: "none",
    stroke: "#00a",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/no data.06c9d469c4511bd5244023368dc420ca.svg";
export { ForwardRef as ReactComponent };